import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h1 {
        font-size: 35px;
        margin-bottom: 10px;
    }
`;

export const Form = styled.form`
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    
    input {
        width: 100%;
        padding: 0 1rem;
        height: 2rem;
        border-radius: 1.25rem;

        border: 1px solid #d7d7d7;
        background: #e7e9ee;

        font-weight: 400;
        font-size: 1rem;
    }

    button[type="submit"] {
        width: 100%;
        padding: 0 1.5rem;
        height: 2rem;
        margin-top: 0.5rem;
        background: #EC1978;
        color: #fff;
        border-radius: 1.25rem;
        border: 0;
        font-size: 1rem;        
        font-weight: 600;
        transition: filter 0.2s;

        &:hover {
            filter: brightness(0.9);
        }

        span {
            margin-left: 0.25rem;
        }
    }
`;